<template>
    <div class="loading-page">
        <div class="loading-container">
            <div class="loading-box">
            </div>
            <div class="process-wrap">
                <div class="process-box process-left" >
                    <div class="process-bar" :style="{ width: process+ '%' }"></div>
                </div>
                <div class="process-box process-right">
                    <div class="process-bar" :style="{ width: process+ '%' }"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "loading",

    components: {

    },
    data: () => ({
        preloadImg: [],
        preloadVideo: [],
        process: 0,
    }),
    created() {
    },
    mounted() {

    },
    watch: {
        process(val) {
            if(val >= 100) {
                setTimeout(() => {
                    this.$emit("loaded", true)
                }, 3000)
            }
        }
    },
    computed: {
    },
    methods: {
    },
};
</script>

<style lang="scss" scoped>
.loading-page {
    background: #1a1b1c;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .loading-container {
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);

        .loading-box {
            width: pxTorem(35px);
            height: pxTorem(35px);
            border: pxTorem(2px) solid #fff;
            transform: rotate(45deg);
            margin: 0 auto;

            &::after {
                content: "";
                position: absolute;
                width: 300%;
                height: 300%;
                top: 50%;
                left: 50%;
                border: pxTorem(10px) solid #fff;
                z-index: -1;
                transform: translate(-50%, -50%);
                animation: news-scale 1s ease-out infinite;

                @keyframes news-scale {
                    0% {
                        transform: translate(-50%, -50%) scale(0.6);
                        opacity: 1;
                    }
                    100% {
                        transform: translate(-50%, -50%) scale(1);
                        opacity: 0;
                    }
                }
            }
        }
        .process-wrap {
            width: 100vw;
            position: relative;
            height: pxTorem(4px);
            margin-top: pxTorem(75px);

            .process-box {
                width: 50%;
                height: 100%;
            }
            .process-left {
                float: left;
                .process-bar {
                    transition: all 3s ease-in-out;
                    float: right;
                    height: 100%;
                    background: #ffd800;
                }
            }
            .process-right {
                float: right;
                .process-bar {
                    transition: all 3s ease-in-out;
                    float: left;
                    height: 100%;
                    background: #ffd800;
                }
            }
        }
    }
}
</style>
